import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class TaxonomyService {
  constructor() {
    this.endpoints = createPrefix('/member', {
      jurisdictions: '/jurisdictions',
      beneficiary: [
        '/beneficiary',
        {
          categories: 'Categories',
          subCategories: 'SubCategories',
        },
      ],
    })
  }

  static create() {
    return new TaxonomyService()
  }

  async queryJurisdictions(params = {}) {
    params.size = params.size ?? 300
    params.search = params.search || ''
    const servicePath = this.endpoints.jurisdictions()
    const { data } = await axios.get(servicePath, { params })
    const { content } = data
    return content
  }

  async queryBeneficiaryCategories(params) {
    const servicePath = this.endpoints.beneficiary.categories()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async queryBeneficiarySubcategories(params) {
    const servicePath = this.endpoints.beneficiary.subCategories()
    const { data } = await axios.get(servicePath, { params })
    return data
  }
}
